import { DUPE_API_URL } from '@dupe/common/constants'
import { useQuery } from '@tanstack/react-query'
import useAuthUser from '~/src/hooks/useAuthUser'
import fetcher from '~/src/lib/fetcher'

export interface UserActivityCounts {
  totalActivities: number
  totalUnclaimed: number
  totalClaimed: number
  totalCashedOut: number
  totalActivityPoints: number
  totalUnclaimedPoints: number
  totalClaimedPoints: number
  totalCashedOutPoints: number
}

export const USER_ACTIVITY_COUNTS_QUERY_KEY = (uid: string | undefined) => [
  'user-activity-counts',
  uid,
]

const useGetUserActivityCounts = (
  { enabled }: { enabled?: boolean } = { enabled: true }
) => {
  const { authUser } = useAuthUser()

  return useQuery<UserActivityCounts>({
    queryKey: USER_ACTIVITY_COUNTS_QUERY_KEY(authUser?.uid),
    queryFn: async () => {
      return fetcher<UserActivityCounts>(
        `${DUPE_API_URL}/api/user/activity-counts`,
        { method: 'GET', authUser }
      )
    },
    enabled: !!authUser?.uid && enabled,
  })
}

export default useGetUserActivityCounts
